import React from 'react';
import { ClaimsPrevention } from '../../services/analyticsService';

interface Props {
  data: ClaimsPrevention;
}

const ClaimsPreventionPanel: React.FC<Props> = ({ data }) => {
  const freqVal = data?.claim_frequency_differential_percent ?? -16;
  const sevVal = data?.average_claim_severity_reduction_percent ?? -24;

  const freqStr = `${freqVal > 0 ? '+' : ''}${Math.round(freqVal)}%`;
  const sevStr = `${sevVal > 0 ? '+' : ''}${Math.round(sevVal)}%`;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 shadow-sm space-y-4">
      <h2 className="text-sm font-bold text-[#0c1e40] leading-snug">
        Claims &amp; Loss-Prevention Reduction
      </h2>

      {/* Top Funnel: Frequency Differential */}
      <div>
        <p className="text-xs font-semibold text-gray-700 mb-2">Claim Frequency Differential</p>
        <div className="flex justify-center">
          <svg viewBox="0 0 140 48" className="w-36 h-12">
            <polygon points="10,0 130,0 108,46 32,46" fill="#2563eb" />
            <text
              x="70"
              y="27"
              textAnchor="middle"
              dominantBaseline="middle"
              className="fill-white font-extrabold text-base"
              style={{ fontSize: '16px', fontWeight: 800 }}
            >
              {freqStr}
            </text>
          </svg>
        </div>
      </div>

      {/* Bottom Funnel: Severity Reduction */}
      <div>
        <p className="text-xs font-semibold text-gray-700 mb-2">Average Claim Severity Reduction</p>
        <div className="flex justify-center">
          <svg viewBox="0 0 140 48" className="w-36 h-12">
            <polygon points="10,0 130,0 108,46 32,46" fill="#2563eb" />
            <text
              x="70"
              y="27"
              textAnchor="middle"
              dominantBaseline="middle"
              className="fill-white font-extrabold text-base"
              style={{ fontSize: '16px', fontWeight: 800 }}
            >
              {sevStr}
            </text>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ClaimsPreventionPanel;
